<template>
  <section class="textSection">
    <div v-if="tableData && tableData.labelHtml">
      <html-renderer :htmlObject="tableData.labelHtml"></html-renderer>
    </div>
    <div class="tableContainer">
      <div class="imageSection" v-if="image && image.src">
        <img class="tableImage" :src="image && image.src" />
      </div>
      <div class="tableSection">
        <activity-table v-if="tableData">
          <thead>
            <tr>
              <th v-for="header in tableData.headers" :key="header.label">{{ header.label }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, idx) in tableData.rows"
              :key="idx"
              :class="getRowClass(row.values.some(val => val.correct))"
            >
              <td v-for="(value, vIdx) in row.values" :key="value.value">
                <tally-marks
                  v-if="
                    tableData.headers[vIdx] &&
                      tableData.headers[vIdx].columnType === KeyboardingTableColumnType.TALLY_MARK
                  "
                  :value="value.value"
                ></tally-marks>
                <div v-else>{{ value.value }}</div>
              </td>
            </tr>
          </tbody>
        </activity-table>
      </div>
    </div>

    <div class="text bottomText">
      <html-renderer :htmlObject="textHtml"></html-renderer>
    </div>
  </section>
</template>

<script>
import { KeyboardingTableColumnType } from '../../graph/types/schema-generated-types';

import ActivityTable from './ActivityTable.vue';
import TallyMarks from './TallyMarks.vue';
import HtmlRenderer from './HtmlRenderer.vue';

export default {
  props: {
    textHtml: {
      type: Object,
      required: true
    },
    shouldShowHints: {
      type: Boolean,
      default: false
    },
    tableData: Object,
    answers: Array,
    image: Object,
    numOfAttempts: Number
  },
  data() {
    return {
      KeyboardingTableColumnType,
      showRowHints: false
    };
  },
  components: {
    ActivityTable,
    TallyMarks,
    HtmlRenderer
  },
  watch: {
    numOfAttempts() {
      if (this.numOfAttempts > 1 && this.shouldShowHints) {
        this.showCorrectAnswers();
      }
    }
  },
  methods: {
    getRowClass(isCorrect) {
      return this.numOfAttempts > 1 && this.showRowHints && isCorrect ? ['rowHint'] : [''];
    },
    showCorrectAnswers() {
      TweenMax.delayedCall(2.5, () => {
        this.showRowHints = true;
      });
      TweenMax.delayedCall(4, () => {
        this.showRowHints = false;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.textSection {
  text-align: left;
}

.bottomText {
  padding: 16px 0;
}

.text {
  display: inline-block;
  text-align: left;
}

.tableImage {
  height: 300px;
  width: 300px;
}
.rowHint {
  background-color: #c6dcc4;
}
.tableContainer {
  display: flex;
  justify-content: center;
  .tableSection {
    flex: 1;
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .imageSection {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
